import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogActions, DialogContent, Link, Stack } from '@mui/material';
import { WsButton, WsDialog, WsTypography, ChatBoxHeader, WsTypoVariants } from 'wisestep-base';

interface IBlockedUserNotification {
  onClose: () => void;
}

export const BlockedUserNotification = ({ onClose }: IBlockedUserNotification) => (
  <WsDialog size="sm" openDialog={true} onClose={onClose}>
    <ChatBoxHeader>
      <WsTypography variant={WsTypoVariants.SUB_TITLE} display="inline" bold={true}>
        Account Blocked
      </WsTypography>
      <CloseIcon
        sx={{ cursor: 'pointer', float: 'right', mt: 0.5 }}
        fontSize={'small'}
        onClick={onClose}
      />
    </ChatBoxHeader>
    <DialogContent>
      <Stack spacing={1}>
        <Box>
          <WsTypography display="inline">
            You account is temporarly blocked due to malecious activity{' '}
          </WsTypography>
        </Box>
        <Box>
          <WsTypography display="inline">Please contact </WsTypography>
          <Link href="mailto:sales@wisestep-inc.com"> sales@wisestep-inc.com </Link>
          <WsTypography display="inline">to reactivate</WsTypography>
        </Box>
      </Stack>
    </DialogContent>
    <DialogActions>
      <WsButton variant="outlined" onClick={onClose}>
        Close
      </WsButton>
    </DialogActions>
  </WsDialog>
);
